var map = {
	"./anjtt-codes.json": [
		7597,
		597
	],
	"./mttv-29nov-2025-codes.json": [
		3940,
		940
	],
	"./schmaetterball-cup-codes.json": [
		6028,
		28
	],
	"./zkm-2025-codes.json": [
		998,
		998
	],
	"./zkm-2025-nachwuchs-codes.json": [
		4857,
		857
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8710;
module.exports = webpackAsyncContext;